<template>
  <div class="c-press-hold">
    <div class="title">
      {{ $t("keyboard.any.title") }}
    </div>
    <div class="fields">
      <md-field class="field">
        <label for="press">{{ $t("keyboard.any.press") }}</label>
        <md-select
          v-model="anyKey.first_key"
          name="press"
          id="press"
          :disabled="disabled || !selectedKey"
        >
          <template v-for="(pressKey, key) in pressKeys">
            <md-option v-if="key" :value="key" :key="'press' + key">
              {{ pressKey.nowrapText }}
              {{
                pressKey.desc ? ` [${pressKey.desc[isCN ? "cn" : "en"]}]` : ""
              }}
            </md-option>
          </template>
        </md-select>
      </md-field>
      <md-field class="field">
        <label for="hold">{{ $t("keyboard.any.hold") }}</label>
        <md-select
          v-model="anyKey.second_key"
          name="hold"
          id="hold"
          :disabled="disabled || !selectedKey"
        >
          <template v-for="(holdKey, key) in holdKeys">
            <md-option v-if="key" :value="key" :key="'hold' + key">
              {{ holdKey.nowrapText }}
              {{ holdKey.desc ? ` [${holdKey.desc[isCN ? "cn" : "en"]}]` : "" }}
            </md-option>
          </template>
        </md-select>
      </md-field>
      <md-field class="field">
        <label>{{ $t("keyboard.any.interval") }}</label>
        <md-input
          v-model="anyKey.interval_time"
          @blur="onIntervalInput"
          type="number"
          min="10"
          max="15000"
          :disabled="disabled || !selectedKey"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
    </div>
    <md-button
      class="button"
      :disabled="
        disabled ||
        !selectedKey ||
        !anyKey.first_key ||
        !anyKey.second_key ||
        !anyKey.interval_time
      "
      @click="onAnyOk"
    >
      {{ $t("yes") }}
    </md-button>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { anyKeys } from "./SpecialKeys";

export default {
  name: "CPressHold",
  props: {
    dispatchType: String,
    profile: {
      type: Object,
      default: () => {},
    },
    selectedKey: String,
    selectedKeyIndex: Number,
    layerIndex: Number,
    pressKeys: {
      type: Object,
      default: () => {},
    },
    holdKeys: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      anyKeys,
      anyKey: {
        ph_key_data: "",
        first_key: null,
        second_key: null,
        interval_time: 200,
      },
      disabled: false,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
  },
  methods: {
    onAnyClick() {
      this.disabled = false;
      let data = this.profile.data;
      if (
        data.tab_key.length >= 199 &&
        !this.anyKeys.includes(this.selectedKey)
      ) {
        this.disabled = true;
        this.$message.info(this.$t("keyboard.any.max"));
      }
      let newKey = "";
      for (let i = 0; i < 200; i++) {
        const key = "#009514" + i.toString(16).toUpperCase().padStart(2, "0");
        const anyKey = data.tab_key.find((k) => k.ph_key_data === key);
        if (!anyKey || !anyKey.first_key) {
          newKey = key;
          break;
        }
      }
      if (this.anyKeys.includes(this.selectedKey)) {
        const anyKey = data.tab_key.find(
          (k) => k.ph_key_data === this.selectedKey
        );
        this.anyKey = {
          ...anyKey,
          ph_key_data: newKey,
          layer_num: this.layerIndex, //当前键层
          row_num: Math.floor(this.selectedKeyIndex / 25), //行
          index: this.selectedKeyIndex % 25, //列
          old_key: this.selectedKey, //新键值
          new_key: newKey, //新键值
        };
      } else {
        this.anyKey = {
          first_key: null,
          second_key: null,
          interval_time: 200,
          ph_key_data: newKey,
          layer_num: this.layerIndex, //当前键层
          row_num: Math.floor(this.selectedKeyIndex / 25), //行
          index: this.selectedKeyIndex % 25, //列
          old_key: this.selectedKey, //新键值
          new_key: newKey, //新键值
        };
      }
    },
    onIntervalInput(e) {
      let time = e.target.value;
      if (time < 10) time = 10;
      if (time > 15000) time = 15000;
      this.anyKey.interval_time = Math.floor(time);
      this.anyKey = { ...this.anyKey };
    },
    onAnyOk() {
      let data = this.profile.data;
      if (this.anyKeys.includes(this.selectedKey)) {
        const index = data.tab_key.findIndex(
          (k) => k.ph_key_data === this.selectedKey
        );
        if (index > -1) {
          data.tab_key[index] = this.anyKey;
          this.$store.dispatch(this.dispatchType, data);
        }
      } else {
        data.tab_key.push(this.anyKey);
        this.$store.dispatch(this.dispatchType, data);
      }
      this.$emit("key-click", this.anyKey.ph_key_data);
    },
  },
  watch: {
    selectedKey(selectedKey) {
      if (selectedKey) this.onAnyClick();
    },
  },
  mounted() {
    if (this.selectedKey) this.onAnyClick();
  },
};
</script>
<style lang="scss" scoped>
.c-press-hold {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;

  .title {
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .fields {
    @include flex-center;
    margin-bottom: 30px;

    .field {
      width: 150px;

      + .field {
        margin-left: 20px;
      }

      .md-input {
        width: 110px;
      }
    }
  }

  .button {
    @include button;
    border: 1px solid $primary-color;
    border-radius: 5px;
    background: transparent;
    color: $primary-color;

    + .button {
      margin-left: 70px;
      background: $primary-color;
      color: #ffffff;
    }

    &:hover {
      color: #ffffff;
    }
  }
}
</style>
